import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review: "The difference in body composition I’ve achieved over a 12 week period plus in the middle of a pandemic and working around gym closures is something I didn’t think would be possible.",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'The process and training was great – every session felt different and challenging whether we progressed with weight, reps or controlled movement.    ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review: "So far I am thrilled with the results, and am looking forward to pushing towards my final goal over the last couple of weeks. To be continued…",
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
